import { useEntity } from 'Context';
import { InternalNotes } from 'Features/InternalNotes';
import React from 'react';

export const ReferralInternalNotes: React.FC = () => {
  const entity = useEntity();

  return <InternalNotes id={entity.id} />;
};
